import createReduxConstant from 'store/util/createReduxConstant';
import { createRequestConstantNames } from 'store/util/createConstants';

export const [
  CANCEL_OD_ROOM_RESERVATION,
  CANCEL_OD_ROOM_RESERVATION_SUCCESS,
  CANCEL_OD_ROOM_RESERVATION_FAIL,
] = createRequestConstantNames(createReduxConstant('CANCEL_OD_ROOM_RESERVATION'));
